const plainTextAdapter = {
  getHighlighter: () => ({ code }) => ({ highlightedCode: code, isHighlighted: false })
};

export { plainTextAdapter };
//# sourceMappingURL=plain-text-adapter.mjs.map
